import "../../../libs/backbone/backbone.ajaxq.adapter.ts";

import Handlebars from 'handlebars';
import Template from 'text-loader!../../templates/analytics/analytics_queues_users_template.html';

import QueuesStatisticsCollection from '../../models/queues_statistics.paginated.collection.ts';

import i18n  from "l10n";

import AnalyticsDatePickerView from './datepicker/analytics-datepicker.view.ts';

export default Backbone.View.extend({
    el: "#statistics-selector",
    tagName: '',
    className: '',
	template: Handlebars.compile(Template),
	venueId: null,
	selection: null, // enum: Queues, Users, Counters
    initialize: function (options) {
        var self = this;

        this.venueId = options ? options.venueId : null;
        this.selection = null;
	},
	superRender: Backbone.View.prototype.render,
	render: function () {
		var self = this;
		this.superRender();

        var templateParams = $.extend({}, this.venueId, {"lang": i18n.lng()});
        var templateData = this.template( templateParams );

		this.$el.html( templateData );

        this.analyticsDatePickerView = new AnalyticsDatePickerView(); // load the Date pickers
        this.analyticsDatePickerView.render();

        return this;
	},
	events:{
	    "click .users-statistics-selector": "loadUserStatistics",
	    "click .queues-statistics-selector": "loadQueueStatistics",
	    "click .counters-statistics-selector": "loadCounterStatistics"
    },
    loadUserStatistics: function(e) {
        this.selection = "Users";

        if(!this.canProceedToSelection(e))
            return;

        if(this.venueId || this.venueId < 1) {
            // toDo: show no Data
            return;
        }
    },
    loadQueueStatistics: function(e) {
        this.selection = "Queues";

        if(!this.canProceedToSelection(e))
            return;

        if(this.venueId || this.venueId < 1) {
            // toDo: show no Data
            return;
        }
    },
    loadCounterStatistics: function(e) {
        this.selection = "Counters";

        if(!this.canProceedToSelection(e))
            return;

        if(this.venueId || this.venueId < 1) {
            // toDo: show no Data
            return;
        }
    },
    canProceedToSelection: function(e) {
        var $elem = $(e.currentTarget);

        if($elem.hasClass("selected")) // clicked the already shown one
            return false;

        if(this.analyticsDatePickerView.$el.find(".date-content").hasClass("display-none"))
            this.analyticsDatePickerView.$el.find(".date-content").removeClass("display-none"); // show datepicker, only if there was a selection between Venue & User

        if($("#filter-dates-button").hasClass("display-none"))
            $("#filter-dates-button").removeClass("display-none"); // show "filter period" button, only if there was a selection between Venue & User

        this.$el.find(".statistics-selector.selected").removeClass("selected");

        $elem.addClass("selected");

        return true;
    }
});


